<!--
 * @Descripttion: 支付信息确认下一步
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="pay-info-confirm-next">
    <div class="pay-info-confirm-next__content">
      <div class="pay-info-confirm-next__content__item">
        <div>项目名称：{{ infoPageData?.projectName }}</div>
        <div>支付订单数量：{{ infoPageData?.payOrderNum }}</div>
        <div>
          支付总金额：{{
            formatter.fen2yuan(infoPageData?.orderPaymentTotalAmount, '元')
          }}
          <span v-if="getTaxType().taxType === 2">（预计）</span>
        </div>
        <div>支付通道：{{ infoPageData?.payPassagewayName }}</div>
      </div>
      <div
        v-for="(item, index) in infoPageData?.statisticsConfirmDetailList"
        :key="index"
        class="pay-info-confirm-next__content__item"
      >
        <div>订单编号：{{ item.orderNo }}</div>
        <div>
          订单类型：{{ ORDER_PRICE_TYPE[item.orderType]?.label || '-' }}
        </div>
        <div v-if="item.orderType === 1 && getTaxType().taxType === 2">
          终端结算金额：{{
            formatter.fen2yuan(item.terminalSettlementAmount, '元')
          }}
        </div>
        <div v-if="item.orderType === 1 && getTaxType().taxType === 2">
          扣除个税金额：{{
            formatter.fen2yuan(item.deductIndividualTaxAmount, '元')
          }}
          <span>（预计）</span>
        </div>
        <div>
          订单支付金额：{{ formatter.fen2yuan(item.orderPaymentAmount, '元') }}
          <span v-if="item.orderType === 1 && getTaxType().taxType === 2">
            （预计）
          </span>
        </div>
        <div>支付对象：{{ item.paymentRecipientDescribe }}</div>
      </div>
    </div>
    <BasePagination
      style="margin: 15px"
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :layout="['total', 'prev', 'pager', 'next', 'jumper']"
      :total="infoData.length"
      @size-change="handleSizeChange"
      @current-change="handleSizeChange"
    ></BasePagination>
    <div style="padding-bottom: 0; padding-right: 0" class="xrk-dialog__footer">
      <BaseButton type="default" @click="props.done">取消</BaseButton>
      <BaseButton :disabled="!payInfo.length" type="primary" @click="onPay">
        发起支付
      </BaseButton>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { maskPhone } from '@/utils/formatter';
import { getVerifyCodeApi, paySubmit } from '../data-source/apis';
import { formatter } from '@/utils';
import { ORDER_PRICE_TYPE } from '../constants';
import {
  BaseButton,
  BaseInput,
  BasePagination,
  XrkMessage,
  createDialog
} from 'xrk-components';
import emitter from '../utils/event-bus';
import router from '@/router';
import { statisticsConfirmList, operatorInfo } from '../data-source/apis';

const props = withDefaults(
  defineProps<{
    done: any;
    payInfo: any[];
  }>(),
  {
    done: () => ({}),
    payInfo: null
  }
);

const getTaxType = () => {
  // 获取订单来自劳务还是经营taxType
  return { taxType: router.currentRoute.value.meta.taxType };
};

const currentPage = ref(1);
const pageSize = ref(1);

const verifyCode = ref('');
const countdown = ref<number>(0);
const codeMsg = ref('获取验证码');

const phoneNumber = ref('');

const getPhoneNumber = async () => {
  const { data } = await operatorInfo({ t: Date.now() });
  phoneNumber.value = data.phone;
};
getPhoneNumber();
const getVerifyCode = async () => {
  if (countdown.value === 0) {
    await getVerifyCodeApi({
      phone: phoneNumber.value
    });
    countdown.value = 60;

    const intervalId = setInterval(() => {
      if (countdown.value === 1) codeMsg.value = '重新获取验证码';

      if (countdown.value > 0) {
        countdown.value--;
      } else {
        clearInterval(intervalId);
      }
    }, 1000);
  }
};

const onPay = async () => {
  const isLine = props.payInfo.some(item => item.payType === 1);
  if (isLine) {
    // 线上支付发送验证码校验
    createDialog({
      title: '支付身份校验',
      showClose: true,
      confirmBtnConfig: {
        content: '确认'
      },
      contentRender: () => {
        return (
          <div style="padding: 20px">
            <span>验证码将发送至您的手机：{maskPhone(phoneNumber.value)}</span>
            <div style="display: flex;margin-top: 20px">
              <BaseInput
                inputTextReplace
                inputTexts={['数字']}
                v-model={verifyCode.value}
                maxlength={6}
                placeholder="请输入验证码"
              />
              <BaseButton
                click={() => {
                  getVerifyCode();
                }}
                disabled={countdown.value > 0}
                type="primary"
                style="margin-left: 5px;width: 100px"
              >
                {countdown.value || codeMsg.value}
              </BaseButton>
            </div>
          </div>
        );
      },
      async beforeConfirm(done) {
        if (!verifyCode.value) {
          XrkMessage.error('请输入验证码');
          return Promise.reject();
        }
        await paySubmit({
          verifyCode: verifyCode.value,
          aspOrderIdList: props.payInfo.map(item => item.aspOrderId).flat()
        });

        XrkMessage.success('支付成功');
        emitter.emit('refresh-order-tabel', { data: true });
        props.done();
        done();
      }
    });
  } else {
    //线下支付不需要验证码
    await paySubmit({
      aspOrderIdList: props.payInfo.map(item => item.aspOrderId).flat()
    });
    XrkMessage.success('支付成功');
    emitter.emit('refresh-order-tabel', { data: true });
    props.done();
  }
};

const infoData = ref([]);

const infoPageData = ref();

const handleSizeChange = ({ currentPage }) => {
  infoPageData.value = infoData.value[currentPage - 1];
};
const getAsyncData = async () => {
  const { data } = await statisticsConfirmList({
    aspOrderIdList: props.payInfo.map(item => item.aspOrderId)
  });
  infoData.value = data;
  infoPageData.value = infoData.value[0];
};
getAsyncData();
</script>
<style lang="scss" scoped>
.pay-info-confirm-next {
  &__content {
    width: 100%;
    &__item {
      margin-bottom: 8px;
      padding: 16px;
      width: 626px;
      background: #fafafa;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #f4f4f5;
      > div {
        margin-bottom: 6px;
      }
    }
  }
}
</style>
